import {jsonMember, jsonObject} from "typedjson";


/** Базовый класс опций для конролов. */
@jsonObject
export class DxBaseControlOptions {
  /**
   * Строковый идентификатор контрола.
   * Можно задавать идентификатор вместе с опциями. То есть один инстанс опций - один контрол.
   * А можно использовать один и тотже объект опций для разных контролов.
   */
  @jsonMember({name: "controlId", constructor: String, emitDefaultValue: false, isRequired: false})
  private _controlId: string;

  /** Лэйбл контрола. */
  @jsonMember({name: "label", constructor: String, emitDefaultValue: false, isRequired: false})
  private _label: string;

  /** Хинт. */
  @jsonMember({name: "hint", constructor: String, emitDefaultValue: false, isRequired: false})
  private _hint: string;

  /** Доступность контрола по умолчанию. */
  @jsonMember({name: "isDisabled", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isDisabled: boolean = false;

  /** Видимость контрола по умолчанию контрола по умолчанию. */
  @jsonMember({name: "isHidden", constructor: Boolean, emitDefaultValue: false, isRequired: false})
  private _isHidden: boolean = false;


  get controlId(): string {
    return this._controlId;
  }

  set controlId(value: string) {
    this._controlId = value;
  }

  get label(): string {
    return this._label;
  }

  set label(value: string) {
    this._label = value;
  }

  get hint(): string {
    return this._hint;
  }

  set hint(value: string) {
    this._hint = value;
  }

  get isDisabled(): boolean {
    return this._isDisabled;
  }

  set isDisabled(value: boolean) {
    this._isDisabled = value;
  }

  get isHidden(): boolean {
    return this._isHidden;
  }

  set isHidden(value: boolean) {
    this._isHidden = value;
  }
}
